module.exports = __webpack_public_path__ + "img/usabilitytest.cea92324.svg";